import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-slechtziende-hoordende',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconSlechtziendeHoordende {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M21.98 0 .68 22.18l.83.82 5.99-6.24c1.26.35 2.6.55 4 .55 5.08 0 9.46-2.5 11.5-6.12-1.17-2.07-3.11-3.77-5.5-4.85L22.8.82zM11.5 5.07c-5.08 0-9.46 2.51-11.5 6.12 1.16 2.07 3.1 3.76 5.48 4.84l2.53-2.63c-.4-.64-.62-1.4-.62-2.21 0-2.3 1.85-4.17 4.11-4.17.76 0 1.47.21 2.08.58l1.91-1.98a14.79 14.79 0 0 0-3.99-.55m0 3.06c-1.67 0-3.02 1.36-3.02 3.06 0 .5.13.97.33 1.38l3.98-4.14c-.39-.19-.83-.3-1.29-.3m3.47.84c.4.64.63 1.4.63 2.22 0 2.3-1.84 4.17-4.1 4.17-.76 0-1.48-.22-2.09-.59l.78-.82c.4.19.84.3 1.31.3 1.67 0 3.01-1.36 3.01-3.06 0-.5-.12-.97-.33-1.39zm12.49 11.42c.78 0 1.51.22 2.15.58l1.02-1.02c-.92-.59-2-.95-3.18-.95-3.24 0-5.87 2.64-5.87 5.88h1.4c0-2.47 2.01-4.48 4.48-4.48Zm3.29 1.46c.73.8 1.19 1.85 1.19 3.01s-1.48 3.46-2.29 4.68c-.14.21-.26.4-.37.56-.3.47-.33 1.13-.36 1.82-.03.79-.07 1.68-.5 1.99-.31.22-.91.22-1.73 0l-.37 1.35c.54.15 1.02.22 1.45.22.59 0 1.09-.14 1.48-.43.97-.71 1.03-2.01 1.07-3.06.02-.39.04-.98.14-1.12.11-.17.23-.35.36-.55 1.01-1.53 2.52-3.85 2.52-5.45 0-1.55-.61-2.95-1.6-4l-.99.99Z"/>
  <path d="m16.993 34.985 17.989-17.989 1.011 1.012-17.989 17.988zM27.46 21.98c.3 0 .59.06.86.15l.83-.83c-.51-.24-1.08-.39-1.69-.39a3.97 3.97 0 0 0-3.96 3.96h1.07c0-1.59 1.3-2.89 2.89-2.89"/>
  <path d="m30.33 22.15-.76.76a2.874 2.874 0 0 1 .53 3.14l.97.46a3.91 3.91 0 0 0-.74-4.36"/>
</svg>

    );
  }
}
